import axios from 'axios';
import qs from 'qs';
import { createInfiniteQuery, createQuery } from 'react-query-kit';

import { HTTP_HEADERS } from '@/constants';
import { restUrl } from '@/services/utils';

import { MonitoringDataType } from './monitor.types';

interface MonitoringsVariables {
    limit: number;
    module?: string;
    term?: string;
    datefilter?: string;
}

interface MonitoringsResponse {
    data: MonitoringDataType[];
    cursor?: string;
}

const useMonitoringData = createInfiniteQuery<MonitoringsResponse, MonitoringsVariables, Error, string | undefined>({
    queryKey: ['monitorings'],
    fetcher: async (variables, { pageParam }) => {

        const response = await axios.get(restUrl('monitorings'), {
            params: variables,
            headers: {
                [HTTP_HEADERS.X_CURSOR]: pageParam
            },
            paramsSerializer: (params) => {
                // We need to remove empty params i.e. '', as it breaks the endpoint.
                const filteredParams = Object.keys(params)
                    .reduce((allParams: Partial<Record<string, any>>, currentParam: string) => {
                        const paramValue = params[currentParam];
                        if (paramValue && paramValue != '') {
                            allParams[currentParam] = paramValue;
                        }

                        return allParams;
                    }, []);

                return qs.stringify(filteredParams);
            }
        });

        return {
            data: response.data?? [],
            cursor: response.headers[HTTP_HEADERS.X_CURSOR]?? undefined
        };
    },
    getNextPageParam: (lastPageRequestResponse) => lastPageRequestResponse.cursor,
    initialPageParam: undefined
});

const useModules = createQuery<string[], void, Error>({
    queryKey: ['monitorings/modules'],
    fetcher: () => {
        return axios.get(restUrl('modules')).then(response => response.data);
    }
});

export { useModules, useMonitoringData };
